import { ConfigManager } from "../../LTGame/Config/ConfigManager";
import { ESceneType } from "../../LTGame/Start/ESceneType";
import LTSplashScene from "../../LTGame/Start/LTSplashScene";
import LoadBinder from "../../ui/Load/LoadBinder";
import UI_splash from "../../ui/Load/UI_splash";
import MainBinder from "../../ui/Main/MainBinder";
import GlobalUnit from "../common/GlobalUnit";
import { AudioConfig } from "../config/AudioConfig";
import { ChallengeDoorConfig } from "../config/ChallengeDoorConfig";
import { CustomConfig } from "../config/CustomConfig";
import { DoorConfig } from "../config/DoorConfig";
import { EffectConfig } from "../config/EffectConfig";
import { EggConfig } from "../config/EggConfig";
import { EnemyConfig } from "../config/EnemyConfig";
import { GameConst } from "../config/GameConst";
import { ItemConfig } from "../config/ItemConfig";
import { LevelConfig } from "../config/LevelConfig";
import { PackConst } from "../config/PackConst";
import { PetConfig } from "../config/PetConfig";
import { PushConfig } from "../config/PushConfig";
import { RewardCodeConfig } from "../config/RewardCodeConfig";
import { RoleConfig } from "../config/RoleConfig";
import { RoleGroup } from "../config/RoleGroup";
import { RollConfig } from "../config/RollConfig";
import { SignConfig } from "../config/SignConfig";
import { SkillConfig } from "../config/SkillConfig";
import { StoreConfig } from "../config/StoreConfig";
import { TryItemConfig } from "../config/TryItemConfig";
import { EffectManager } from "../manager/EffectManager";
export default class SplashScene extends LTSplashScene {
    constructor() {
        super();
        this._splashUIClass = UI_splash;
        this._useCommonUI = true;
    }
    _OnBindUI() {
        LoadBinder.bindAll();
        MainBinder.bindAll();
    }
    _OnSetLoadConfig() {
        ConfigManager.AddConfig(AudioConfig);
        ConfigManager.AddConfig(EffectConfig);
        ConfigManager.AddConfig(GameConst);
        ConfigManager.AddConfig(PackConst);
        ConfigManager.AddConfig(EggConfig);
        ConfigManager.AddConfig(RewardCodeConfig);
        ConfigManager.AddConfig(SignConfig);
        ConfigManager.AddConfig(RollConfig);
        ConfigManager.AddConfig(TryItemConfig);
        ConfigManager.AddConfig(PushConfig);
        ConfigManager.AddConfig(LevelConfig);
        ConfigManager.AddConfig(RoleConfig);
        ConfigManager.AddConfig(ItemConfig);
        ConfigManager.AddConfig(EnemyConfig);
        ConfigManager.AddConfig(SkillConfig);
        ConfigManager.AddConfig(PetConfig);
        ConfigManager.AddConfig(StoreConfig);
        ConfigManager.AddConfig(CustomConfig);
        ConfigManager.AddConfig(DoorConfig);
        ConfigManager.AddConfig(ChallengeDoorConfig);
        ConfigManager.AddConfig(RoleGroup);
    }
    _OnGameResPrepared(urls) {
        GlobalUnit.InitAll(urls);
        EffectManager.instance.Preload(urls);
    }
    _OnGameResLoaded() {
        return __awaiter(this, void 0, void 0, function* () {
            yield EffectManager.instance.WarmEffects();
            yield GlobalUnit.FirstCreate();
            this.isFinished = true;
            this.nextState = ESceneType.Main;
        });
    }
}
